<template>
  <div class="field" v-if="obj.watching === true">
    <form class="login" v-model="valid" ref="maxpriceform" lazy-validation v-on:submit.prevent>
        <div class="field">
            <label class="label">Max price for alerts:</label>
  
            <div v-if="isHidden">
                <div class="field is-grouped no-gap">
                    <div class="control">
                        <span class="button is-static no-outline">{{ maxPrice }}</span>
                    </div>
                    <div class="control">
                        <button class="button is-text" @click="edit" :disabled="!valid">Edit</button>
                    </div>
                </div>
            </div>

            <div v-if="!isHidden">
                <div class="field has-addons">
                    <div class="control">
                        <!-- <a class="button is-static is-white">£</a> -->
                        <span class="button is-static no-outline">£</span>
                    </div>
                    <div class="control">
                        <input class="input is-success" v-model="maxPrice" v-validate="'required|min:1|numeric'" ref="inputfield" type="number" name="maxprice" placeholder="Maximum price" />
                    </div>
                    <div class="control">
                        <button class="button is-primary" @click="save" v-bind:disabled="errors.any()" type="submit" name="submit">Save</button>
                    </div>
                    <div class="control">
                        <button class="button is-text" @click="cancel" type="submit" name="submit" id="submit">Cancel</button>
                    </div>
                </div>
            </div>

          

          <!-- <div class="control">
            <button class="button is-link" @click="setMaxPrice" :disabled="!valid">Submit</button>
          </div> -->
          
          <!-- <div class="field">
              <label class="label">Max price {{maxPrice}}</label>
              <div class="control">
                <div class="select">
                  <select name="maxprice" v-validate="'required'" v-bind:class="{'is-danger': errors.has('maxprice')}" v-model="maxPrice">
                    <option value="">Nothing selected</option>
                    <option v-for="option in options.prices" v-bind:value="option.value">
                      {{ option.text }}
                    </option>
                  </select>
                </div>
              </div>
          </div> -->

        </div>

        
    </form>

  </div>
</template>

<script>
import Api from '@/config/Api'; // MCH added

const placeholderText = 'Any price';

export default {
    props: ['item'],
    data () {
      return {
        //obj: {},
        valid: true,
        maxPrice: placeholderText,
        isHidden: true,
        /* options: {
          prices: [
            { value: '47600', text: "£476"},
            { value: '54400', text: "£544"},
            { value: '61200', text: "£612"},
            { value: 'anyprice', text: "Any price"},
            { value: 'custom', text: "Custom"}
          ]
        } */
      }
    },
    computed: {
        obj() {
          if (!this.item.watching) {
            this.maxPrice = placeholderText;
          } else if (this.item.maxPrice) {
            this.maxPrice = this.item.maxPrice;
          }
          return this.item;
        }
    },
    methods: {
        edit() {
            this.isHidden = false;
            this.$nextTick(() => {
                this.$refs.inputfield.focus();
            })
        },
        save() { // save:function(evt) {
            // evt.preventDefault();
            if (this.maxPrice == this.obj.maxPrice) { // if no change, abort
                this.isHidden = true;
                return;
            }

            var maxprice = this.maxPrice;

            this.obj.maxPrice = maxprice;
            console.log("setMaxPrice",maxprice);
            console.log("item id",this.obj._id);
              /*if(this.name && this.age) return true;
              this.errors = [];
              if(!this.name) this.errors.push("Name required.");
              if(!this.age) this.errors.push("Age required.");*/
            
            var options = {        
              maxPrice: maxprice,
            }
            if (this.obj.hasOwnProperty('products')) { // because only productGroups have 'products' property
              options.productGroupId = this.obj._id;
            } else {
              options.productId = this.obj._id;
            }
            Api().put('/api/user/maxPrice', options)
            .then(response => {
              console.log("response:",response.data);
              this.$swal('Updated maximum price!', `We'll let you know when it's in stock for ${maxprice} or less`, 'success');
              // this.$router.push({ name: 'home' });
              this.isHidden = true;
            })
            .catch((error) => {
              console.log("errrr:",error);
              const message = error.response.data.message;
              this.$swal('Oh oo!', `${message}`, 'error');
            });
        },
        cancel() {
            if (this.obj.maxPrice) {
                this.maxPrice = this.obj.maxPrice;
            }
            this.isHidden = true;
        }
    }
}
</script>

<style scoped>

.no-outline {
    border-color: white !important;
    background-color: white !important;
}
.no-gap .control {
    margin-right: 0 !important;
}   
.no-gap span {
    padding-left: 0;
    padding-right: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/cards/MaxPriceWidget.vue